import { render } from "./TheCouponName.vue?vue&type=template&id=3a2f605e&scoped=true"
import script from "./TheCouponName.vue?vue&type=script&lang=js"
export * from "./TheCouponName.vue?vue&type=script&lang=js"

import "./TheCouponName.vue?vue&type=style&index=0&id=3a2f605e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3a2f605e"

export default script